import React from 'react';
import ProcurementTable from './ProcurementTable';

const HydrocarbonCondensatTable = ({ refreshTrigger }) => (
  <ProcurementTable procurementTypeHeader='2' refreshTrigger={refreshTrigger} />
);

export default React.memo(HydrocarbonCondensatTable);
